<template lang="pug">
include ../../plugins/pug/template
div
  v-data-table(
    :headers="headers"
    :items="items"
    :items-per-page="pageSize"
    :loading="isLoad"
    loading-text="Завантаження..."
    no-results-text="Дані не знайдено"
    no-data-text="Даних немає"
    hide-default-footer
    :server-items-length="countItems || (Array.isArray(items) ? items.length : 0)"
    :options.sync="options"
  )
    template(
      v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="slotProps"
    )
      slot(
        :name="slotName"
        v-bind="slotProps"
      )
    template(#header.status_statement).d-flex
      div.d-flex.align-center
        span {{ $t('status') }}
        //- заготовка для відкриття модального вікна де будуть розписані всі статуси які є у таблиці і що вони значать
        //- v-tooltip(bottom open-delay="200")
        //-   template(v-slot:activator="{ on, attrs }")
        //-     v-btn(icon)
        //-       v-icon(size="16" v-bind="attrs" v-on="on") mdi-information-outline
          span Натисніть, щоб ознайомитись
    template(#item.markWithModel="{ item }")
      div.text--primary.b-600.white-space-nowrap
        span.mr-1 {{ item.vehicle_mark_name }}
        span {{ item.vehicle_model_name }}
        span(v-if="item.vehicle_modification_name") &nbsp;{{ item.vehicle_modification_name }}

    template(#item.vehicle_mark="{ item }")
      span.text--primary.b-600 {{ directoryById('vehicleMark', item.vehicle_mark).name }}

    template(#item.vehicle_model="{ item }")
      span.text--primary.b-600 {{ directoryById('vehicleModel', item.vehicle_model).name }}

    template(#item.created_at="{ item }")
      span.text--primary.b-600 {{ $moment(item.created_at).format('HH:mm DD.MM.YYYY') }}

    template(#item.expiry="{ item }")
      span.text--primary.b-600 {{ $moment(item.expiry).format('HH:mm DD.MM.YYYY') }}

    template(#item.last_activity="{ item }")
      span.text--primary.b-600 {{ $moment(item.last_activity).format("HH:mm DD.MM.YYYY") }}

    template(#item.is_current_session="{ item }")
      span.text--primary.b-600 {{ item.is_current_session ? $t('yes') : $t('no') }}

    template(#item.clientAbbr="{ item }")
      span.text--primary.b-600 {{ item.client_full_name }}

    template(#item.userFIO="{ item }")
      span.text--primary.b-600 {{ clientFIO(item) }}

    template(#item.laboratory="{ item }")
      div.text--primary.b-600
        div {{ item.laboratoryBranchOffice.name }}
      div.text--primary.b-600
        div {{ item.laboratoryBranchOffice.address }}

    template(#item.branchAddress="{ item }" )
      div.text--primary.b-600 {{ branchAddress(item.address) }}

    template(#item.categoriesVehicle="{ item }")
      v-tooltip(max-width="400" left open-delay="200" color="blue-grey")
        template(v-slot:activator="{ on, attrs }")
          div(
            v-bind="attrs"
            v-on="on"
            style={
              'white-space': 'nowrap',
              'max-width': '400px',
              'overflow': 'hidden',
              'text-overflow': 'ellipsis'
            }
          ).text--primary.b-600 {{ categoriesVehicleGroups(item.allow_categories) }}
        div.categories-tooltip
          div.categories-tooltip__group(
            v-for="(group, groupIndex) in categoriesVehicleGrouped(item.allow_categories)"
            :key="`group-${ groupIndex }`"
          )
            span.categories-tooltip__bullet •
            span {{ group }}

    template(#item.userPassports="{ item }")
      div.text--primary.b-600 {{ passportData(item.user_passports[0]) }}

    template(#item.legal_acts="{ item }")
      div.mb-1(:key="i" v-for="(act, i) in item.legal_acts").text--primary.b-600
        div {{ directoryById('legalActs', act).inspection_name }}
        div {{ directoryById('legalActs', act).name }}

    template(#item.direction="{ item }")
      v-chip(class="ma-2 font-weight-bold" :color="directionContractStatement(item).color" small)
        span.mr-1 {{ $t(directionContractStatement(item).text) }}
        v-icon(small) {{directionContractStatement(item).icon}}

    template(#item.organizationEDRPOU="{ item }")
      div.text--primary.b-600 {{ organizationEDRPOU(item) }}

    template(#item.organizationName="{ item }")
      div.text--primary.b-600 {{ organizationName(item) }}

    template(#item.status_statement="{ item }")
      v-chip(:color="statuses.statement(item.status_document).color")
        span(:class="statuses.statement(item.status_document).textColor").b-600 {{ $t(statuses.statement(item.status_document).text) }}

    template(#item.status_statement_manual="{ item }")
      v-chip(:color="statuses.statementManual(item.status_document).color")
        span.text--white.b-600 {{ $t(statuses.statementManual(item.status_document).text) }}

    template(#item.status_statement_mti="{ item }")
      v-chip(:color="statuses.statementMTI(item.status_document).color")
        span(:class="statuses.statementMTI(item.status_document).textColor").b-600 {{ $t(statuses.statementMTI(item.status_document).text) }}

    template(#item.status_contract="{ item }")
      v-chip(:color="statuses.contractDecision(item.decision).color")
        span.text--white.b-600 {{ $t(statuses.contractDecision(item.decision).text) }}

    template(#item.status_statement_branch="{ item }")
      v-chip(:color="statuses.statementBranch(item.statement_step).color" v-if="item.statement_step" )
        span.text--white.b-600 {{ $t(statuses.statementBranch(item.statement_step).text) }}
      template(v-else-if="item?.is_updating")
        v-chip(color="orange" textColor="white")
          span.text--white.b-600 {{$t("waitingModeration")}} 
          //- після редагування дільниці при полі is_updating - світимо особливий статус
      template(v-else)
        v-chip(:color="statusWorkLine(item.has_moderation_lines).color")
          span.text--white.b-600 {{ $t(statusWorkLine(item.has_moderation_lines).text) }}

    template(#item.last_name_employee="{ item }")
      div(v-if="item.has_rejected_reviews || item.has_rejected_files_reviews").employeeHasWrongField
      div.d-flex
        v-tooltip(bottom v-if="item.has_rejected_reviews || item.has_rejected_files_reviews")
          template(v-slot:activator="{ on, attrs }")
            v-icon(color="error" v-bind="attrs" v-on="on").mr-4 mdi-alert-circle
          span(v-html="$t('wrongField.employeeHasWrongField', { name: `${item.last_name} ${item.first_name} ${item.middle_name}` })")
        span {{ item.last_name }}

    template(#item.branch_name="{ item }")
      div(v-if="item.has_rejected_reviews || item.has_rejected_files_reviews").employeeHasWrongField
      div.d-flex
        v-tooltip(bottom v-if="item.has_rejected_reviews || item.has_rejected_files_reviews")
          template(v-slot:activator="{ on, attrs }")
            v-icon(color="error" v-bind="attrs" v-on="on").mr-4 mdi-alert-circle
          span(v-html="$t('wrongField.branchHasWrongField', { name: item.name })")
        span {{ item.name }}

    template(#item.status_cooperation_agreement="{ item }")
      v-tooltip(
        v-if="item.is_expire_soon && item.contract_status === 1"
        bottom
        open-delay="200"
      )
        template(v-slot:activator="{ on, attrs }")
          v-badge(
            bordered
            overlap
            :color="'error'"
            :content="'!'"
            v-bind="attrs"
            v-on="on"
          ).mr-6
            v-chip(:color="statuses.cooperationAgreement(item.contract_status).color" v-bind="attrs" v-on="on")
              span.text--white.b-600 {{ $t(statuses.cooperationAgreement(item.contract_status).text) }}
        span {{ item.is_expire_soon ? $t('contract.needsExtension', [Math.ceil($moment(new Date(item.contract_end_date)).diff($moment(new Date()), 'days', true))]) : $t('statuses.statementDecisionValid') }}
      v-chip(v-if="!item.is_expire_soon || item.contract_status === 2" :color="statuses.cooperationAgreement(item.contract_status).color")
        span.text--white.b-600 {{ $t(statuses.cooperationAgreement(item.contract_status).text) }}

    template(#item.action="{ item }")
      router-link(:to="detailedRoute + item.id ")
        v-icon(color="info") mdi-arrow-right

    template(#item.view="{ item }")
      +btn-icon('primary', 'mdi-eye')(@click="$emit('view', item.id)")

    template(#item.delete="{ item }")
      v-icon(color="error" @click="$emit('delete', item.pk_md5 ? item.pk_md5 : item.id)") mdi-delete

    template(#item.edit="{ item }")
      +btn-icon('primary', 'mdi-pencil')(@click="$emit('edit', item.id)")

    template(#item.actionBranch="{ item }")
      +btn-icon('error', 'mdi-delete')(@click="$emit('deleteBranch', item.id)" v-if="!item.has_rejected_reviews && !item.has_rejected_files_reviews" )
      +btn-icon('primary', 'mdi-pencil')(@click="$emit('editBranch', item.id)" v-if="item.has_rejected_reviews || item.has_rejected_files_reviews")

    template(#item.employeeStatus="{ item }")
      v-chip(
        :color="statuses.employeeStatus(employeeStatus(item)).color"
      )
        span(:class="statuses.employeeStatus(employeeStatus(item)).textColor").b-600 {{ $t(statuses.employeeStatus(employeeStatus(item)).text) }}

    template(#item.employeeOutOfSystemStatus="{ item }")
      v-chip(
        :color="statuses.employeeOutOfSystemStatus(employeeStatus(item)).color"
      )
        span(:class="statuses.employeeStatus(employeeStatus(item)).textColor").b-600 {{ $t(statuses.employeeOutOfSystemStatus(employeeStatus(item)).text) }}

    template(#item.employeeDeactivationAndActivation="{ item }")
      v-tooltip(bottom open-delay="200" v-if="item.user_status === 1 || [1, 2].includes(item.statement_employee_status)")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('error', 'mdi-delete')(@click="$emit('delete', item.id)" v-on="on")
        span {{ $t('btn.deactivate') }}

      v-tooltip(bottom open-delay="200" v-if="[2, 3].includes(item.user_status) || item.statement_employee_status === 4")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('success lighten-1', 'mdi-delete-restore')(@click="$emit('restore', item.id)" v-on="on")
        span {{ $t('btn.activate') }}

    template(#item.userAction="{ item }")
      v-tooltip(bottom open-delay="200" v-if="item.user_status === 1")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('error', 'mdi-delete')(@click="$emit('delete', item.id)" v-on="on")
        span {{ $t('btn.remove') }}

      v-tooltip(bottom open-delay="200" v-if="[2, 3].includes(item.user_status)")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('success lighten-1', 'mdi-delete-restore')(@click="$emit('restore', item.id)" v-on="on")
        span {{ $t('btn.restore') }}

      v-tooltip(bottom open-delay="200")
        template(v-slot:activator="{ on, attrs }")
          router-link(:to="detailedRoute + item.id").px-2
            v-icon(color="primary" v-on="on") mdi-pencil
        span {{ $t('btn.edit') }}

      v-tooltip(bottom open-delay="200")
        template(v-slot:activator="{ on, attrs }")
          router-link(:to="detailedRoute + item.id + '/view' ").px-2
            v-icon(color="primary" v-on="on") mdi-eye
        span {{ $t('btn.view') }}

    template(#item.type_user_translate="{ item }")
      div {{ userRoleName(item.type_user) }}
    template(#footer v-if="countItems")
      v-divider
      div.footer.grayLight
        div.d-flex.justify-space-between
          div.d-flex.align-center.ml-4
            template(v-if="countItems > 5")
              span {{ capitalizeFirstLetter($t(labelPage)) }} {{ $t('on') }} {{ $t('page') }}
              span.mr-4
                +select({ model: 'pageSize', items: 'listPageSize' })(
                  @input="changeCount"
                  hide-details).customSelect
              v-divider(vertical)
            span.footer__range.ml-4 {{rangeDisplayItems}} з {{ countItems || 0 }} {{ $t(labelPage) }}
          div.d-flex.align-center
            v-divider(vertical)
            span.ml-2.py-4
              +select({ model: 'page', items: 'listPages' })(
                @input="(page) => changePage(page, pageSize)"
                hide-details).customSelect
            span.mr-4 з {{ pageCount }} {{ $t('pages') }}
            v-divider(vertical)
            span.px-4
              v-btn(icon :disabled="page === 1" color="info" @click="handleClickChangePage('prev')")
                v-icon mdi-chevron-left
            v-divider(vertical)
            span.px-4
              v-btn(icon :disabled="page === pageCount" color="info" @click="handleClickChangePage('next')")
                v-icon mdi-chevron-right
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { access } from '@/configs/permissions'
import statuses from '@/configs/statuses'
import { list as statusesList } from '@/configs/statuses'
import { employeeType, roleListUserVL, streetTypeAbbr } from '@/configs/constants'
import getLabelTypeStreet from '@/mixins/getLabelTypeStreet'

import { capitalizeFirstLetter } from '@/configs/helpers'
export default {
  mixins: [getLabelTypeStreet],
  props: {
    headers: { type: Array, default: () => ([]) },
    items: { type: Array, default: () => ([]) },
    detailedRoute: { type: String, default: '' },
    changePage: { type: Function, default: () => {} },
    useServerOptions: { type: Boolean, default: false },
    isLoad: { type: Boolean, default: false },
    isHideHeader: { type: Boolean, default: false },
    countItems: { type: Number, default: 0 },
    labelPage: { type: String, default: 'record' }
  },
  data () {
    return {
      statuses,
      statusesList,
      page: 1,
      check: false,
      access,
      employeeType,
      roleListUserVL,
      listPageSize: [5, 10, 20, 50],
      pageSize: 10,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      capitalizeFirstLetter
    }
  },
  computed: {
    ...mapState({}),
    ...mapGetters(['directoryById']),
    branchAddress () {
      return address => {
        if (!address) {
          return ''
        }
        const parts = []
        if (address.index) {
          parts.push(`${ address.index }`)
        }
        if (address.city) {
          parts.push(`м. ${ address.city }`)
        }
        if (address.region) {
          parts.push(`${ address.region }`)
        }
        if (address.street) {
          const streetTypeKey = this.getLabelTypeStreet(address.type_street)
          const streetLabel = streetTypeKey && streetTypeAbbr[streetTypeKey] !== undefined
            ? streetTypeAbbr[streetTypeKey]
            : (streetTypeKey ? this.$t(streetTypeKey) : '')
          const formattedStreet = streetLabel
            ? `${ streetLabel } ${ address.street }`
            : `${ address.street }`
          parts.push(formattedStreet.trim())
        }
        if (address.house) {
          parts.push(`буд.${ address.house }`)
        }
        if (address.flat) {
          parts.push(`кв.${ address.flat }`)
        }
        return parts.join(', ')
      }
    },
    clientFIO () {
      return user => {
        return `${ user.last_name } ${ user.first_name } ${ user.middle_name }`
      }
    },
    categoriesVehicle () {
      return categories => {
        if (categories.length && typeof categories[0] === 'number') {
          let categoriesNameString = []
          categories.forEach(e => categoriesNameString.push(this.directoryById('vehicleCategory', e)?.name))
          return categoriesNameString.join(', ')
        }
        return categories.join(', ')
      }
    },
    categoriesVehicleGroups () {
      return categories => {
        if (!categories?.length) return ''
        const categoriesList = categories.length && typeof categories[0] === 'number'
          ? categories?.map(e => this.directoryById('vehicleCategory', e)?.name)?.filter(Boolean) ?? []
          : categories?.filter(Boolean) ?? []
        if (!categoriesList?.length) return ''
        const firstLetters = [...new Set(categoriesList?.map(cat => cat ? cat?.[0] : '')?.filter(Boolean))]
        return firstLetters.join(', ') + '…'
      }
    },
    categoriesVehicleGrouped () {
      return categories => {
        if (!categories?.length) return []
        const categoriesList = categories?.length && typeof categories[0] === 'number'
          ? categories?.map(e => this.directoryById('vehicleCategory', e)?.name).filter(Boolean)
          : categories?.filter(Boolean)
        if (!categoriesList?.length) return []
        const grouped = {}
        categoriesList?.forEach(cat => {
          if (cat) {
            const firstLetter = cat?.[0]
            if (!grouped[firstLetter]) {
              grouped[firstLetter] = []
            }
            grouped[firstLetter].push(cat)
          }
        })
        
        return Object?.keys(grouped)?.sort()?.map(letter => {
          return grouped?.[letter]?.join(', ') + ';'
        })
      }
    },
    passportData () {
      return userPassportData => userPassportData ?
        `${ userPassportData.serial } / ${ userPassportData.inn }` :
        '--- / ---'
    },
    organizationName () {
      return item => {
        if (this.access('viewContractLabInfo')) {
          return item.sender.certification_agency ? item.consumer.name : item.sender.name
        }
        if (this.access('viewContractOCInfo')) {
          return item.sender.measuring_laboratory ? item.consumer.name : item.sender.name
        }
      }
    },
    organizationEDRPOU () {
      return item => {
        if (this.access('viewContractLabInfo')) {
          return item.sender.certification_agency ? item.consumer.EDPROU : item.sender.EDPROU
        }
        if (this.access('viewContractOCInfo')) {
          return item.sender.measuring_laboratory ? item.consumer.EDPROU : item.sender.EDPROU
        }
      }
    },
    directionContractStatement () {
      return item => {
        if (this.access('viewContractLabInfo')) {
          return item.sender.certification_agency
            ? { icon: 'mdi-arrow-top-right-thin', text: 'contract.directionOut', color: 'green lighten-3' }
            : { icon: 'mdi-arrow-bottom-left-thin', text: 'contract.directionIn', color: 'yellow lighten-3' }
        }
        if (this.access('viewContractOCInfo')) {
          return item.sender.measuring_laboratory
            ? { icon: 'mdi-arrow-top-right-thin', text: 'contract.directionOut', color: 'green lighten-3' }
            : { icon: 'mdi-arrow-bottom-left-thin', text: 'contract.directionIn', color: 'yellow lighten-3' }
        }
      }
    },
    employeeStatus () {
      // eslint-disable-next-line no-bitwise
      return item => item.user_status | item.statement_employee_status
    },

    statusWorkLine () {
      return hasModerationLines => {
        if (hasModerationLines) {
          return this.statuses.workLineStatus(this.statusesList.workLineWaitFilling)
        }
        return this.statuses.workLineStatus(this.statusesList.workLineApproved)
      }
    },
    userRoleName () {
      return typeUser => roleListUserVL.find(e => e.type_user === typeUser)?.role
    },
    pageCount () {
      return Math.ceil(this.countItems/this.pageSize || 0)
    },
    listPages () {
      let list = [1]
      let i = 2
      while(i <= this.pageCount) {
        list.push(i)
        i++
      }
      return list
    },
    rangeDisplayItems () {
      let fromNumber = ((this.page * this.pageSize) - this.pageSize) + 1
      let toNumber = this.pageSize * this.page
      return `${fromNumber} -
      ${(toNumber > this.countItems ? this.countItems : toNumber)}` || ''
    }
  },
  watch: {
    options: {
      handler (val) {
        if (!this.useServerOptions) return
        this.page = val.page
        this.pageSize = val.itemsPerPage
        this.$emit('update:options', val)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['getDirectoryById']),
    clientNameFormatted (fullName) {
      if (fullName && fullName.replace(/^\s+|\s+$/gm, '')) {
        const name = fullName.split(' ')
        let middleName = name[2][0] ? `${ name[2][0] }.` : ''
        return `${ name[0] } ${ name [1][0] }. ${ middleName }`
      }
      return '---'
    },
    changeCount (item) {
      this.page = 1
      if (this.useServerOptions) {
        this.options = {
          ...this.options,
          page: this.page,
          itemsPerPage: item
        }
      } else {
        this.changePage(this.page, item)
      }
    },
    handleClickChangePage (value) {
      if (value === 'next') this.page += 1
      else if (value === 'prev') this.page -= 1
      if (this.useServerOptions) {
        this.options = {
          ...this.options,
          page: this.page
        }
      } else {
        this.changePage(this.page, this.pageSize)
      }
    }
  }
}
</script>
<style lang="sass">
@import '@/assets/sass/constants.sass'
.categories-tooltip
  max-width: 400px
  max-height: calc(100vh - 200px)
  overflow-y: auto
  display: flex
  flex-direction: column
  gap: 4px

  &__group
    display: flex
    align-items: flex-start
    white-space: normal
    line-height: 1.4

  &__bullet
    margin-right: 6px
    flex-shrink: 0
.footer
  .customSelect
    .v-text-field > .v-input__control > .v-input__slot fieldset
      border: none !important
      background: #F9FAFB

    .v-select
      &__slot
        max-width: 66px
        text-align: center
        width: max-content !important
        input
          min-width: 25px !important
          text-align: center
@media screen and (max-width: 1024px)
  .footer__range
    display: none
</style>